import Modal from "~/common/components/Modal";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { openModal } from "~/common/utils/ModalService";
import { useTranslation } from "react-i18next";
import { LinkButton } from "~/common/components/Link";
import { type Attribute } from "~/features/selectionAssistant/bearing/components/AbbreviationListModal/constants";
import { Box, Stack } from "~/common/mui";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface Props {
  onClose: () => void;
  attributes: Attribute[];
}

export const AbbreviationListModal = (props: Props) => {
  const { t } = useTranslation();
  const isMinTabletSize = useIsMinTabletSize();
  return (
    <Modal onClose={props.onClose} title={t("page.sa.common.seeAbbreviations")}>
      <Box sx={{ mt: { xs: 12, tablet: 0 } }}>
        <Stack direction="column" spacing={2}>
          {props.attributes.map((attribute) => (
            <div>
              {attribute.symbol} - {attribute.name}
            </div>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};

interface BtnProps {
  className?: string;

  attributes: Attribute[];
}
export const OpenAbbreviationsBtn = ({ className, attributes }: BtnProps) => {
  const { t } = useTranslation();

  const onClick = () =>
    openModal("abbreviation-list-modal", (close) => <AbbreviationListModal onClose={close} attributes={attributes} />);

  return (
    <LinkButton className={className} onClick={onClick} iconBefore={<InfoOutlinedIcon  />}>
      {t("page.sa.common.seeAbbreviations")}
    </LinkButton>
  );
};
